export { Caption1, caption1ClassNames } from './components/presets/Caption1/index';
